/* eslint-disable react/forbid-prop-types */
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Message } from '@design-system-coopeuch/web';

import { stepperAction } from '../../../../application/actions/stepper';
import { Wrapper } from './styles';
import DatosPersonalesCard from '../../atoms/DatosPersonalesCard';
import DatosLaboralesCard from '../../atoms/DatosLabolaresCard';
import { capitalize } from '../../../../utils/index';

const DatosPersonalesTemplate = ({
  activeMenu,
  listacontrato,
  listaAno,
  infoDatosPersonales,
  listaPaises,
  listaRegiones,
  listaComunas,
  listaCargos,
  obtenerValoresDatosLaborales,
  obtenerCargos,
  obtenerPaisDatosPersonales,
  obtenerRegionDatosPersonales,
  obtenerComunaDatosPersonales,
  obtenemosContratoDL,
  obtenemosTiempoTrabajandoDL,
  cambioEstadoFormularioDatosLadorales,
  dataDatosPersonales,
  dataDatosLaborales,
  obtenerCargoDatosLaborales,
  independienteTiempo,
  autorizoFunction,
  setAutorizo,
}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(stepperAction.fetchStepper(activeMenu));
  }, [activeMenu]);

  const {
    nombres,
    primerApellido,
    segundoApelllido,
    email,
    rutEmpleador,
    nombreEmpleador,
    convenio,
    socio,
    antiguedad,
    pais,
    contrato,
    celular
  } = infoDatosPersonales;

  const { activarDatosLaboalres } = dataDatosPersonales;

  const nombreUsuario = `${nombres} ${primerApellido} ${segundoApelllido}`;
  const splitString = nombres.split(' ');
  const lowerCarse = splitString[0];
  const textoBold = `¡Hola ${capitalize(lowerCarse)}!`;
  const descripcionMessage = `${textoBold} tu RUT ha sido validado. Completa tus datos.`;

  return (
    <Wrapper>
      <div className="header_datos_personales">
        <Message
          action={undefined}
          description={descripcionMessage}
          onClickClose={undefined}
          title=""
          type="info"
        />
      </div>

      <DatosPersonalesCard
        paisSeleccionadoCard={obtenerPaisDatosPersonales}
        regionSeleccionadaCard={obtenerRegionDatosPersonales}
        comunaSeleccionadaCard={obtenerComunaDatosPersonales}
        nombreUsuarioCard={nombreUsuario}
        dataFormulario={dataDatosPersonales}
        listaPaisesCard={listaPaises}
        listaRegionesCard={listaRegiones}
        listaComunasCard={listaComunas}
        emailCard={email}
        pais={pais}
        celular={celular.toString()}
        capturarValoresFormularioFuncion={obtenerValoresDatosLaborales}
        autorizoFunction={(t) => autorizoFunction(t)}
        setAutorizo={setAutorizo}
      />

      <DatosLaboralesCard
        pais={pais}
        setContrato={contrato}
        activarDatosLaboalresCard={activarDatosLaboalres}
        formularioEstadoFunction={cambioEstadoFormularioDatosLadorales}
        capturarValoresFormularioFuncion={obtenerValoresDatosLaborales}
        obtenerCargoDatosLaborales={obtenerCargoDatosLaborales}
        obtenemosContratoDatosLabolares={obtenemosContratoDL}
        obtenemosTiempoTrabajandoDatosLabolares={obtenemosTiempoTrabajandoDL}
        seleccionCargoFunction={obtenerCargos}
        rutEmpleadorCard={rutEmpleador}
        nombreEmpleadorCard={nombreEmpleador}
        socioCard={socio}
        convenioCard={convenio}
        listaCargosCard={listaCargos}
        listacontratoCard={listacontrato}
        listaAnoCard={listaAno}
        antiguedadLaboralCard={antiguedad}
        dataFormulario={dataDatosLaborales}
        tiposDeCargoIndependiente={independienteTiempo}
      />
    </Wrapper>
  );
};
DatosPersonalesTemplate.propTypes = {
  activeMenu: PropTypes.number,
  listacontrato: PropTypes.arrayOf(PropTypes.object),
  listaAno: PropTypes.arrayOf(PropTypes.object),
  infoDatosPersonales: PropTypes.objectOf(PropTypes.any),
  listaPaises: PropTypes.arrayOf(PropTypes.object),
  listaRegiones: PropTypes.arrayOf(PropTypes.object),
  listaComunas: PropTypes.arrayOf(PropTypes.object),
  listaCargos: PropTypes.arrayOf(PropTypes.object),
  obtenerValoresDatosLaborales: PropTypes.func,
  obtenerCargos: PropTypes.func,
  dataDatosPersonales: PropTypes.objectOf(PropTypes.any),
  dataDatosLaborales: PropTypes.objectOf(PropTypes.any),
  // overFormularioLaborales: PropTypes.func,
  obtenerPaisDatosPersonales: PropTypes.func,
  obtenerRegionDatosPersonales: PropTypes.func,
  obtenerComunaDatosPersonales: PropTypes.func,
  cambioEstadoFormularioDatosLadorales: PropTypes.func,
  obtenerCargoDatosLaborales: PropTypes.func,
  obtenemosContratoDL: PropTypes.func,
  obtenemosTiempoTrabajandoDL: PropTypes.func,
  independienteTiempo: PropTypes.arrayOf(PropTypes.any),
  autorizoFunction: PropTypes.func,
  setAutorizo: PropTypes.bool,
};
DatosPersonalesTemplate.defaultProps = {
  activeMenu: '',
  listacontrato: [],
  listaAno: [],
  infoDatosPersonales: {},
  listaPaises: [{}],
  listaRegiones: [{}],
  listaComunas: [{}],
  listaCargos: [{}],
  obtenerValoresDatosLaborales: () => {},
  obtenemosContratoDL: () => {},
  obtenerCargos: () => {},
  dataDatosPersonales: [{}],
  dataDatosLaborales: [{}],
  // overFormularioLaborales: () => { },
  obtenerPaisDatosPersonales: () => {},
  obtenerRegionDatosPersonales: () => {},
  obtenerComunaDatosPersonales: () => {},
  cambioEstadoFormularioDatosLadorales: () => {},
  obtenemosTiempoTrabajandoDL: () => {},
  obtenerCargoDatosLaborales: () => {},
  independienteTiempo: [{}],
  autorizoFunction: () => {},
  setAutorizo: '',
};
export default DatosPersonalesTemplate;
